<template>
  <div class="hello">
    <a href="#/bugs">昆虫图鉴</a>
    <h1 v-if="iscurrent==2">全鱼类图鉴</h1>
    <h1 v-if="iscurrent==3">{{month}}月份鱼类图鉴</h1>
    <h2 v-if="iscurrent==1">{{month}}月份{{hour}}时鱼类图鉴[{{banq==1?"北半球": "南半球"}}]</h2>
    <div>版本:0.5</div>
    <div class="footer1"></div>
    <fish v-for="(fish,idx) in fishes" v-bind:banq="banq" v-bind:key="idx" v-bind:fish="fish"></fish>
    <div class="footer"></div>
    <div class="planetool">
        <!-- <div id="d1"> -->
           <select id="s1" v-model='banq'>
          <option value="1">北半球</option>
          <option value="2">南半球</option>
          </select>
                   <select id="s2" v-model="sort" >
          <option value="1">按序号正序</option>
          <option value="2">按序号倒序</option>
          <option value="3">按价格倒序</option>
          <option value="4">按价格正序</option>
        </select>
          <select id="s3" v-model="location">
          <option value="All">全部地点</option>
          <option value="Pond">池塘</option>
          <option value="River">河流</option>
          <option value="River (Mouth)">仅出现在入海口</option>
          <option value="River (Clifftop)">仅出现在悬崖河流</option>
          <option value="Sea">海洋</option>
          <option value="Pier">仅出现在码头</option>
        </select>
             <!-- </div> -->
       <!-- <div id="d4"> -->
         <select id="s4" v-model="size">
          <option value="All">全部大小</option>
          <option value="Very Small">非常小</option>
          <option value="Small">小</option>
          <option value="Medium">中等</option>
          <option value="Large">大</option>
          <option value="Huge">巨大</option>
          <option value="Long & Thin">细长</option>
          <option value="Finned">有鱼鳍</option>
        </select>
        <!-- </div> -->
         <!-- <div id="d5"> -->
            <select id="s5" v-model='iscurrent'>
          <option value="1">此时能钓的</option>
          <option value="3">本月份图鉴</option>
          <option value="2">全图鉴</option>
        </select>
         <!-- </div> -->
    </div>
  </div>
</template>

<script>
import Fish from '@/components/Fish'
export default {
  components: {
    'fish': Fish
  },
  name: 'HelloWorld',
  computed: {
    month: function () {
      let date = new Date()
      let month = date.getMonth() + 1
      return month
    },
    hour: function () {
      let date = new Date()
      let hour = date.getHours()
      return hour
    },
    fishes: function () {
      let that = this
      return this.fish.filter(function (e) {
        if (that.size !== 'All') {
          if (e.esize !== that.size) return false
        }
        if (that.location !== 'All') {
          if (e.elocation !== that.location) return false
        }
        if (that.iscurrent === '2') return true
        // window.console.log(e.fseasonn.join("-"))
        // window.console.log(e.ftime)
        let f = that.banq === '1' ? e.fseasonn : e.fseasons
        // window.console.log(f.join(':'))
        let m = that.month
        let monthOk = false
        for (let index = 0; index < f.length; index++) {
          const element = f[index]
          if (element.length === 1) {
            if (element[0] === '全年') {
              break
            } else if (that.month === element[0]) {
              break
            }
          } else if (element.length === 2) {
            let a = element[0]
            let b = element[1]
            // window.console.log(a, b, m)
            if (a < b) {
              monthOk = monthOk || (m >= a && m <= b)
            } else {
              monthOk = monthOk || (m >= a || m <= b)
            }
          }
        }
        // console.log(e.cname, monthOk)
        if (!monthOk) return false
        if (that.iscurrent === '3') return true
        if (e.ctime !== '全天') {
          let o = that.hour
          if (e.ftime.length === 2) {
            let a = e.ftime[0]
            let b = e.ftime[1]
            window.console.log(a, b, o)
            if (a < b) {
              return o >= a && o < b
            } else if (a > b) {
              return o >= a || o < b
            }
          } else if (e.ftime.length === 4) {
            // window.console.log(e.ftime,o)
            let a = e.ftime[0]
            let b = e.ftime[1]
            let ok = false
            if (a < b) {
              ok = ok || (o >= a && o < b)
            } else if (a > b) {
              ok = ok || (o >= a || o < b)
            }

            a = e.ftime[2]
            b = e.ftime[3]
            if (a < b) {
              ok = ok || (o >= a && o < b)
            } else if (a > b) {
              ok = ok || (o >= a || o < b)
            }

            if (!ok) return false
          }
        }
        return true
      }).map(function (e) {
        e.img = 'https://gamewith-en.akamaized.net/article_tools/animal-crossing-new-horizons/gacha/sakana_' + e.id + '_i.png'
        e.simg = 'https://gamewith-en.akamaized.net/article_tools/animal-crossing-new-horizons/gacha/shadow_' + e.size + '.png'
        return e
      }).sort(function (a, b) {
        if (that.sort === '1') return a.id - b.id
        else if (that.sort === '2') return b.id - a.id
        else if (that.sort === '3') return b.price - a.price
        else if (that.sort === '4') return a.price - b.price
      })
    }
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      fish: window.fish,
      locations: ['任意', '悬崖上河流', '河流', '河流入海口', '码头', '海洋', '池塘'],
      location: 'All',
      banq: '1',
      iscurrent: '1',
      size: 'All',
      sort: '1'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.footer1{
  height: 40px;
}
.footer{
  height: 90px;
}
.planetool{
  position: fixed;
  width: 90%;
  height: 70px;
  /* background-color: rgba(242, 235, 200, 0.9); */
  bottom: 15px;
  left: 15px;
  right:15px;
  margin-left: 0px;
  border-radius:25px;
}

.planetool {
  margin-top: 2px;
  text-align: left;
  opacity: 0.8;
}
.planetool select {
  background-color: #42b983;
  color: white;
  padding: 4px;
  width: 90px;
  border: none;
  font-size: 12px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
  -webkit-appearance: button;
  appearance: button;
  outline: none;
  margin: 4px;
}

.planetool div::before {
  content: "选择";
  font-family: FontAwesome;
  position: absolute;
  /* top: 0; */
  left: 80px;
  width: 50px;
  /* height: 100%; */
  text-align: center;
  font-size: 14px;
  line-height: 26px;
  color: rgba(0, 0, 0, 0.5);
  background-color: rgba(255, 255, 255, 0.3);
  pointer-events: none;
}
#d1::before {
  content: "半球";
}
#d2::before {
  content: "排序";
}
#d3::before {
  content: "地点";
}
#d4::before {
  content: "影子";
}
#d5::before {
  content: "月时";
}

.planetool:hover::before {
  color: rgba(255, 255, 255, 0.6);
  background-color: rgba(255, 255, 255, 0.2);
}

.planetool select option {
  padding: 30px;
}

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue